/**
 * versionPanelStore — open/closed state for the Version Control panel.
 *
 * Module singleton + subscribe, the same shape as bakeSettingsStore, and for
 * the same reason: the panel now has TWO doors and they must not each own a
 * copy of "is it open".
 *
 * It used to be a `useState` inside ContentBrowser, reachable only from the ⎇
 * button in the assets-dock toolbar — so version control could not be opened
 * with the dock collapsed, and a rail button could not exist at all. Lifting
 * the flag here lets the tool rail open it (as it already does for Bake
 * Lighting and Build Navmesh) while the toolbar button keeps working, with one
 * source of truth behind both.
 *
 * Deliberately NOT persisted: unlike a window's geometry — which FloatingWindow
 * keeps in windowStore so a reopened panel comes back where you left it — a
 * panel that reopens itself on every boot is noise, not a restored session.
 */
let state = { open: false }
const listeners = new Set()

function emit() {
  if (typeof window !== 'undefined') window.__VERSION_PANEL__ = state
  for (const fn of listeners) fn()
}

export const versionPanelStore = {
  getState() { return state },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn) },
  open() { if (!state.open) { state = { open: true }; emit() } },
  close() { if (state.open) { state = { open: false }; emit() } },
  toggle() { state = { open: !state.open }; emit() },
}

export default versionPanelStore
